import Cookies from 'universal-cookie';

const LEGACY_PHP_SESSID_COOKIE = 'PHPSESSID';
const MKEY_COOKIE = 'mobile_key';
const MAINTENANCE_COOKIE = 'en4_maint_code';
const CASINO_SOUNDS_ON = 'casino_sounds_on';

const OPTIONS = {
  path: '/',
  domain: process.env.REACT_APP_COOKIE_DOMAIN,
  secure: process.env.REACT_APP_SECURE_COOKIE === 'true',
  maxAge: process.env.REACT_APP_COOKIE_MAX_AGE || 2592000 // Defaults maxAge to 1 month.
};

const cookies = new Cookies();

export function setLegacyCookie(cookie) {
  cookies.set(LEGACY_PHP_SESSID_COOKIE, cookie, OPTIONS);
}

export function clearLegacyCookie() {
  cookies.remove(LEGACY_PHP_SESSID_COOKIE, OPTIONS);
}

export function setMKeyCookie(mKey) {
  cookies.set(MKEY_COOKIE, mKey, OPTIONS);
}

export function getMKeyCookie() {
  return cookies.get(MKEY_COOKIE);
}

export function setMaintenanceCookie(code) {
  cookies.set(MAINTENANCE_COOKIE, code, OPTIONS);
}

export function clearMaintenanceCookie() {
  cookies.remove(MAINTENANCE_COOKIE, OPTIONS);
}

export function setCasinoSoundsCookie(cookie) {
  cookies.set(CASINO_SOUNDS_ON, cookie, OPTIONS);
}

export function getCasinoSoundsCookie() {
  return cookies.get(CASINO_SOUNDS_ON);
}



// WEBPACK FOOTER //
// ./src/utils/cookies.js